module.exports = __webpack_public_path__ + "static/media/close-white-24dp.48434575.svg";